import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Michael & Ashlynn</h3>
            <p>November 29, 2025</p>
            <p>Milwaukee, Wisconsin</p>
          </div>

          {/* <div className="footer-section">
            <h4>Contact</h4>
            <p>For questions about the wedding:</p>
            <p>Email: wedding@michaelandashlynn.com</p>
            <p>Phone: (555) 123-4567</p>
          </div> */}

          {/* <div className="footer-section">
            <h4>Follow Our Journey</h4>
            <div className="social-links">
              <a href="#" className="social-link">
                Instagram
              </a>
              <a href="#" className="social-link">
                Facebook
              </a>
              <a href="#" className="social-link">
                Twitter
              </a>
            </div>
          </div> */}
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2025 Michael & Ashlynn. Made with <FontAwesomeIcon icon={faHeart} /> for our special day.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
